import styles from './simple-select.module.scss';
import type { ChangeEventHandler } from 'react';

type SimpleSelectProps = {
	initialValue: string;
	handleChange: ChangeEventHandler<HTMLSelectElement>;
	options: { name: string; value: string; isDisabled?: boolean }[];
	id: string;
};

const SimpleSelect = ({
	initialValue,
	handleChange,
	options,
	id,
}: SimpleSelectProps) => {
	return (
		<div className={styles.selectWrapper}>
			<select
				className={styles.select}
				name={id}
				id={id}
				value={initialValue}
				onChange={handleChange}
			>
				{options.map((option) => (
					<option
						key={option.value}
						value={option.value}
						disabled={option.isDisabled}
					>
						{option.name}
					</option>
				))}
			</select>
		</div>
	);
};

export default SimpleSelect;
